import { DtoCataloguePermission, groupAndSortCataloguePermissions } from "@configura/web-api";
import React, { useEffect, useMemo, useState } from "react";
import { CatalogueCard } from "./CatalogueCard";
import FilterInput from "./FilterInput";
import styles from "./index.module.css";
import { PageFooter } from "./PageFooter";
import { PageHeader } from "./PageHeader";

type Props = {
	cataloguePermissions: DtoCataloguePermission[];
	browsingRootUrl: string; // The root of product browsing
};

export const Home: React.FC<Props> = (props) => {
	const { cataloguePermissions, browsingRootUrl } = props;

	const [filterString, setFilterString] = useState<string>("");
	const [filteredCataloguePermissions, setFilteredCataloguePermissions] =
		useState(cataloguePermissions);

	const catalogues = useMemo(
		() => groupAndSortCataloguePermissions(filteredCataloguePermissions),
		[filteredCataloguePermissions]
	);

	const enterprises = useMemo(() => Object.keys(catalogues), [catalogues]);

	useEffect(() => {
		setFilteredCataloguePermissions(
			cataloguePermissions.filter((cat) =>
				cat.prdCat.toLowerCase().includes(filterString.toLowerCase())
			)
		);
	}, [filterString, cataloguePermissions]);

	return (
		<main className={styles.home}>
			<PageHeader>Example app</PageHeader>
			<p>This is an example implementation using the Catalogue API and SDK.</p>

			<h2>List of catalogues</h2>
			<p>
				<FilterInput parentFunction={setFilterString} />
			</p>

			<div className={styles.enterpriseWrapper}>
				{enterprises.length === 0 && <div>No product catalogues here yet.</div>}
				{enterprises.length === 1 && (
					<ul className={styles.cardGrid}>
						{filteredCataloguePermissions.map((c) => (
							<CatalogueCard
								{...c}
								browsingRootUrl={browsingRootUrl}
								showEnterprise={true}
								key={`${c.cid}-${c.enterprise}-${c.prdCat}-${c.prdCatVersion}`}
							/>
						))}
					</ul>
				)}
				{enterprises.length > 1 &&
					enterprises.map((enterprise) => (
						<ul key={enterprise} className={styles.enterpriseList}>
							<li>
								<h3 className={styles.enterpriseList__header}>{enterprise}</h3>
								<ul className={styles.cardGrid}>
									{catalogues[enterprise].map((c) => (
										<CatalogueCard
											{...c}
											browsingRootUrl={browsingRootUrl}
											key={`${c.cid}-${c.enterprise}-${c.prdCat}-${c.prdCatVersion}`}
										/>
									))}
								</ul>
							</li>
						</ul>
					))}
			</div>
			<PageFooter>Example footer</PageFooter>
		</main>
	);
};
